import React from 'react';
import PropTypes from 'prop-types';
import * as Icons from '../icons/Icons';


const EditTemplate = ({ children, status, header, onConfirmClick, onCancelClick }) => (
    <div>
        <div>{header}</div>
        <div className="rec-edit-wrap">
            {children}
            <div>
                {status}
                <button
                    className="rec-apply-updates"
                    name="ok"
                    aria-label="Apply Edits"
                    title="Apply Edits"
                    onClick={onConfirmClick}>
                    <Icons.IconCheck />
                </button>

                <button
                    className="rec-cancel-updates"
                    name="cancel"
                    aria-label="cancel"
                    title="Cancel Edits"
                    onClick={onCancelClick}>
                    <Icons.IconClose />
                </button>
            </div>
        </div>
    </div>
);

EditTemplate.propTypes = {
    children: PropTypes.oneOfType([
        PropTypes.arrayOf(PropTypes.any),
        PropTypes.string,
        PropTypes.object
    ]),
    status: PropTypes.element,
    header: PropTypes.element,
    onConfirmClick: PropTypes.func.isRequired,
    onCancelClick: PropTypes.func.isRequired
};

EditTemplate.defaultProps = {
    status: null,
    children: null
};

export default EditTemplate;
